import { useState } from "react";

import { CheckIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

import { readSwatches } from "./swatches";

export * from "./swatches";

interface ColorPickerProps {
  value?: string | null;
  onChange: (color: string) => void;
  /** `aria-labelledby` uchun — forma yorlig'ining id'si. */
  labelledBy?: string;
}

/**
 * Palitradan rang tanlash.
 *
 * Ranglar `src/index.css` dagi `--swatch-*` tokenlaridan o'qiladi: formada
 * bironta qotib qolgan hex yo'q, palitra almashsa bu komponent avtomatik
 * yangi ranglarni ko'rsatadi.
 */
export const ColorPicker = ({ value, onChange, labelledBy }: ColorPickerProps) => {
  const { t } = useTranslation();
  /**
   * Tokenlar CSS da yashaydi, ya'ni qiymatni faqat brauzer hisoblab beradi.
   * Dangasa initsializator — effekt EMAS: effekt ichidagi `setState` birinchi
   * chizishdan keyin darhol ikkinchisini keltirib chiqaradi va palitra
   * ko'zga tashlanadigan tarzda "sakraydi".
   */
  const [colors] = useState<string[]>(() => readSwatches(document.documentElement));

  return (
    <div role="radiogroup" aria-labelledby={labelledBy} className="flex flex-wrap gap-2">
      {colors.map(color => {
        const selected = value?.toLowerCase() === color;

        return (
          <button
            key={color}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={t("COMMON.COLOR_OPTION", { color })}
            onClick={() => onChange(color)}
            style={{ backgroundColor: color }}
            className={cn(
              "ring-offset-background grid size-8 place-items-center rounded-lg ring-offset-2 transition-shadow",
              selected ? "ring-ring ring-2" : "hover:ring-border hover:ring-2",
            )}
          >
            {selected && <CheckIcon className="text-background size-4" />}
          </button>
        );
      })}
    </div>
  );
};
